<template>
  <div>
    <div
      class="card-header first-header card-expandable"
      id="headingOne"
      data-toggle="collapse"
      data-target="#collapseOne"
      aria-expanded="true"
      aria-controls="collapseOne"
    >
      <div class="title">
        <i class="feather-icon icon-file-plus"></i>
        <h5 class="mb-0">ค้นหาข้อมูลหนังสือค้ำประกันเดิม</h5>
      </div>
    </div>
    <div
      id="collapseOne"
      class="collapse show"
      aria-labelledby="headingOne"
      data-parent="#accordion"
    >
      <div class="card-body compact-padding">
        <div class="default-padding">
          <div class="form-row">
            <div class="form-group col-md-6">
              <label>เลขที่หนังสือค้ำประกันเดิม</label>
              <input
                v-model="contingent"
                type="text"
                class="form-control"
                placeholder
              />
            </div>
            <div class="form-group no-label col-md-3">
              <label></label>
              <button
                class="btn btn-lg btn-primary-ktb"
                type="button"
                @click="searchRequest()"
              >
                ค้นหา
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="this.appVo != null && this.appVo.requesterTaxId != null"
        id="collapseOne"
        class="collapse show"
        aria-labelledby="headingOne"
        data-parent="#accordion"
      >
        <div class="card-body compact-padding">
          <div class="default-padding">
            <div class="data-display mb-3">
              <table class="two-col-data">
                <tbody>
                  <tr>
                    <th>Tax ID</th>
                    <td class="important">{{ appVo.requesterTaxId }}</td>
                  </tr>

                  <tr>
                    <th>ชื่อลูกค้า (Th)</th>
                    <td>{{ appVo.requesterNameTh }}</td>
                  </tr>

                  <tr>
                    <th>ชื่อลูกค้า (En)</th>
                    <td>{{ appVo.requesterNameEn }}</td>
                  </tr>

                  <tr>
                    <th>ที่อยู่ลูกค้า</th>
                    <td>
                      {{ appVo.requesterAddr }}&nbsp;&nbsp;{{
                        appVo.requesterSubDistrict
                      }}&nbsp;&nbsp;{{ appVo.requesterDistrict }}&nbsp;&nbsp;{{ appVo.requesterProvince }}&nbsp;&nbsp;{{
                        appVo.requesterZipcode
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="form-row">
              <div class="form-group no-label col-md-5">
                <label>ผู้รับผลประโยชน์(ผู้รับหนังสือค้ำประกัน)</label>
              </div>
              <div class="form-group no-label col-md-7">
                {{ appVo.beneNameTh }}
              </div>
            </div>

            <div class="form-row">
              <div class="form-group no-label col-md-5">
                <label>ประเภทค้ำประกัน</label>
              </div>
              <div class="form-group no-label col-md-7">
                {{ appVo.contingentTypeName }}
              </div>
            </div>
            <div class="form-row" v-bind:class="{ hideForm: isHideForm }">
              <div class="form-group no-label col-md-5">
                <label>รหัสแบบฟอร์มหนังสือค้ำประกัน</label>
              </div>
              <div
                class="form-group no-label col-md-7"
                v-if="this.appVo != null && this.appVo.modifyFlag === 'Y'"
              >
                <select
                  v-model="lgFormNoExtendTop"
                  name="lgFormNo"
                  class="form-control"
                  v-validate="'required'"
                  :class="{ input: true, 'is-danger': errors.has('lgFormNo') }"
                >
                  <option value="">กรุณาเลือก</option>
                  <option
                    v-for="option in lgFormList"
                    v-bind:value="option.lgFormNo"
                    :key="option.lgFormNo"
                    >{{ option.lgFormNo }}</option
                  >
                </select>
              </div>
              <div class="form-group no-label col-md-7" v-else>
                {{ appVo.lgFormNo }}
              </div>
            </div>
            <div class="form-row">
              <div class="form-group no-label col-md-5">
                <label>หมายเลขบัญชีวงเงิน</label>
              </div>
              <div class="form-group no-label col-md-7">{{ appVo.commNo }}</div>
            </div>

            <div class="form-row">
              <div class="form-group no-label col-md-5">
                <label>จำนวนเงินค้ำประกัน(บาท)</label>
              </div>
              <div class="form-group no-label col-md-7">
                {{ formatPrice(appVo.lgAmt) }}
              </div>
            </div>

            <div
              class="option-form mb-4"
              v-if="
                appVo != null &&
                  appVo.requesterList != null &&
                  appVo.requesterList.length > 0
              "
            >
              <div class="form-group">
                <label>เพื่อค้ำประกันในนาม</label>
                <div v-if="this.appVo != null && (this.appVo.modifyFlag === 'Y' || this.lgGroup === 'NHSO')">
                  <b-table
                    striped
                    hover
                    :items="appVo.requesterList"
                    :fields="fields"
                  >
                    <template v-slot:cell(guaranteeTaxId)="row">
                      <b-form-input
                        v-model="row.item.guaranteeTaxId"
                        disabled
                      />
                    </template>
                    <template v-slot:cell(guaranteeName)="row">
                      <b-form-input v-model="row.item.guaranteeName" />
                    </template>
                    <template v-slot:cell(guaranteeNameEN)="row">
                      <b-form-input v-model="row.item.guaranteeNameEN" />
                    </template>
                  </b-table>
                </div>
                <div v-else>
                  <b-table
                    striped
                    hover
                    :items="appVo.requesterList"
                    :fields="fields"
                  ></b-table>
                </div>
              </div>
            </div>

            <component
              :reqType="reqType"
              :appVo="appVo"
              :beneGroup="appVo.beneGroup"
              :lgFormNo="lgFormNoExtendTop"
              :beneTaxId="appVo.beneTaxId"
              :is="dynamicBene"
              v-on:childToParent="onChildChange"
              v-bind:specificVo="specificVo"
              v-bind:lgSpecificFields="lgSpecificFields"
            />

            <div class="form-row">
              <div class="form-group no-label col-md-3">
                <label>ระยะเวลาในการค้ำประกัน</label>
              </div>
              <div class="form-group no-label col-md-2">
                <label>ตั้งแต่วันที่</label>
              </div>
              <div class="form-group no-label col-md-3">
                <date-picker
                  v-model="oldperiodStartDate"
                  name="oldperiodStartDate"
                  lang="th"
                  format="DD/MM/YYYY"
                  placeholder
                  disabled
                ></date-picker>
              </div>

              <div class="form-group no-label col-md-1">
                <label>ถึงวันที่</label>
              </div>
              <div class="form-group no-label col-md-3">
                <date-picker
                  v-model="oldperiodEndDate"
                  lang="th"
                  format="DD/MM/YYYY"
                  placeholder
                  disabled
                ></date-picker>
              </div>
            </div>
          </div>

          <component
            :reqType="reqType"
            :appVo="appVo"
            :lgType="lgType"
            :is="dynamicBC"
            v-on:childExtToParent="onChildExtChange"
            v-bind:lgSpecificFields="lgSpecificFields"
           
          />

          <div
            class="card-header first-header card-expandable"
            id="headingOne"
            data-toggle="collapse"
            data-target="#collapseOne"
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            <div class="title">
              <i class="feather-icon icon-file-plus"></i>
              <h5 class="mb-0">ข้อมูลต่ออายุ และ/หรือ เพิ่มวงเงินค้ำประกัน</h5>
            </div>
          </div>
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordion"
          >
            <div class="default-padding">
              <component
                ref="extendComponent"
                :appVo="appVo"
                :reqType="reqType"
                :oldperiodEndDate="oldperiodEndDate"
                :is="dynamicExtType"
                v-on:onChildExtIncChange="onChildExtIncChange"
              />
              <component
                ref="incComponent"
                :appVo="appVo"
                :reqType="reqType"
                :commNo="commNo"
                :lgType="lgType"
                :oldperiodEndDate="oldperiodEndDate"
                :feeAmt="feeAmt"
                :is="dynamicIncType"
                v-on:onChildIncChange="onChildIncChange"
              />
            </div>
          </div>
          <hr />

          <div class="default-padding">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>ค่าธรรมเนียม</label>
              </div>
            </div>

            <div
              class="form-row"
              v-if="
                this.appVo.bcFlagByComNo === '1' || this.bcFlagByComNo === '1'
              "
            >
              <div class="form-group col-md-6">
                <label>ค่าธรรมเนียม(บาท)</label>
                <vue-numeric
                  separator=","
                  v-bind:precision="2"
                  v-model="feeAmt"
                  name="feeAmt"
                  class="form-control"
                  readonly
                ></vue-numeric>
              </div>
            </div>

            <div
              class="form-row"
              v-if="
                this.appVo.bcFlagByComNo === '1' || this.bcFlagByComNo === '1'
              "
            >
              <div class="form-group col-md-6">
                <label>ตัดบัญชีค่าธรรมเนียมอัตโนมัติ</label>
                <input
                  v-model="accNoFee"
                  type="text"
                  class="form-control"
                  name="accNoFee"
                  v-validate="{ required: true }"
                  :class="{ input: true, 'is-danger': errors.has('accNoFee') }"
                  placeholder
                  readonly
                />
              </div>
              <div class="form-group col-md-6">
                <label>จำนวนเงินคงเหลือในบัญชี(บาท)</label>
                <vue-numeric
                  separator=","
                  v-bind:precision="2"
                  v-model="accBalFee"
                  name="accBalFee"
                  class="form-control"
                  readonly
                ></vue-numeric>
              </div>
            </div>

            <div
              class="form-row"
              v-if="
                (this.appVo.bcFlag === '1' &&
                  this.appVo.bcFlagByComNo !== '1') ||
                  (this.appVo.bcFlag !== '1' && this.bcFlagByComNo !== '1')
              "
            >
              &nbsp;
              <span class="text-red"
                >ค่าธรรมเนียมขั้นต่ำ 500 บาท หรือเป็นไปตามระเบียบธนาคาร</span
              >
            </div>
          </div>
        </div>

        <div
          class="card-header first-header card-expandable"
          id="headingOne"
          data-toggle="collapse"
          data-target="#collapseOne"
          aria-expanded="true"
          aria-controls="collapseOne"
        >
          <div class="title">
            <i class="feather-icon icon-file-plus"></i>
            <h5 class="mb-0">เอกสารประกอบเพิ่มเติม</h5>
          </div>
        </div>
        <div
          id="collapseOne"
          class="collapse show"
          aria-labelledby="headingOne"
          data-parent="#accordion"
        ></div>
        <div class="card-body compact-padding">
          <div class="default-padding">
            <div class="doctype-body">
              <div
                class="default-padding"
                v-for="(item, index) in docTypeList"
                :key="index"
                v-bind:id="'docType' + index"
              >
                <p>
                  <span
                    class="text-red result-bold"
                    v-if="item.mandatFlag === 'Y'"
                    >*</span
                  >
                  {{ item.docTypeDesc }}
                </p>
                <vue-dropzone
                  v-bind:ref="'myVueDropzone' + index"
                  v-bind:id="'dropzone' + index"
                  v-on:vdropzone-removed-file="imageRemoved"
                  v-on:vdropzone-error="uploadError"
                  v-on:vdropzone-processing="
                    initUpload('myVueDropzone' + index, item.docTypeId)
                  "
                  v-on:vdropzone-success="successUpload"
                  :options="dropzoneOptions"
                  :destroyDropzone="false"
                ></vue-dropzone>
                <br /><br />
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center mt-4">
          <div class="col-6 col-sm-5 col-lg-5 col-xl-4">
            <div class="cta-btn single-btn">
              <button
                class="btn btn-lg btn-primary-ktb"
                type="button"
                @click="saveRequest()"
              >
                บันทึก
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import AppFooter from "../pagecomp/appFooter";
import AppHeader from "../pagecomp/appHeader";
import { AUTH_LOGOUT } from "@/store/actions/auth";
import { mapGetters } from "vuex";
import axios from "axios";
import Loading from "@/components/lib/loading";

import { apiClient } from "@/utils/apiClient";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
//import DatePicker from "vue2-datepicker";
import DatePicker from "@/resources/datepicker/vue2-datepicker";
import Lgmain from "../request/lgmain";
import moment from "moment";

export default {
  props: ["beneCode", "lg", "reqType", "specificVo", "lgSpecificFields"],
  components: {
    AppFooter,
    AppHeader,
    vueDropzone: vue2Dropzone,
    DatePicker,
    Lgmain,
  },
  data() {
    return {
      isHideForm: false,
      lgFormNoExtendTop: "",
      ctrDatePEA: "",
      ctrDate: "",
      percentage: "",
      projectName: "",
      fields: [
        {
          key: "guaranteeTaxId",
          sortable: true,
          label: "Tax ID",
        },
        {
          key: "guaranteeName",
          sortable: true,
          label: "ชื่อภาษาไทย",
        },
        {
          key: "guaranteeNameEN",
          sortable: true,
          label: "ชื่อภาษาอังกฤษ",
        },
      ],
      reqNo: "",
      reqTypeNew: "",
      reqTypeExt: "",
      reqTypeInc: "",
      appVo: [],
      beneficiary: {
        beneTaxId: localStorage.getItem("beneTaxId"),
        beneGroup: localStorage.getItem("beneGroup"),
        beneName: "",
      },
      beneficiaryList: [],
      lgType: "",
      lgGroup: "",
      custLgTypeList: [],
      commList: [],
      docTypeList: [],
      periodType: "",
      status1: "",
      status2: "",
      status3: "",
      accountNo: "",
      majorStampAmt: "",
      minorStampAmt: "",
      dutyStampAmt: "",
      periodStartDate: "",
      periodStartDate1: "",
      periodStartDate2: "",
      periodEndDate: "",
      extperiodStartDate: "",
      extperiodStartDate1: "",
      extperiodStartDate2: "",
      extperiodEndDate: "",
      periodAmt: "",
      periodUnit: "",
      lgAmt: "",
      feeRate: "",
      feeAmt: "",
      accNoFee: "",
      accBal: "",
      accNoStamp: "",
      accBalStamp: "",
      extPeriodType: 2,
      extPeriodStartDate1: "",
      extPeriodStartDate2: "",
      extPeriodEndDate: "",
      contingent: "",
      addLgAmt: "",
      sumLgAmt: "",
      addPeriodStartDate: "",
      addPeriodEndDate: "",
      commNo: "",
      oldperiodStartDate: "",
      oldperiodEndDate: "",
      oldperiodStartDateEn: "",
      oldperiodEndDateEn: "",
      extperiodStartDate1Text: "",
      extperiodStartDate2Text: "",
      extperiodEndDateText: "",
      bcFlagByComNo: "",
      contingentTypeId: "",
      beneficiaryRemark: "",
      mtContingentId: "",
      lgFormNo: "",
      bcFlag: "",
      lgTypeName: "",
      refDropZone: "",
      ctrName: "",
      lgFormList: [],
      manyCtrNo: "",
      manyCtrDate: "",
      guaranteePriceAmt: "",
      hospitalCode: "",
      hospitalName: "",
      contractTypeId: 0,
      contractTypeDesc: "",
      contractPeriod: "",
      projectId:"",
      seqNo:"",
      projectBudgetAmt:"",
      bidExpireDate:"",
      projectOwner:"",
      advancePaymentAmt:"",
      collectionPhase:"",
      docSeq: "",
      productType:"",
      dealerCode:"",
      manyCtrName: "",
      lgDescription3: "",
      lgDescription2: "",
      lgDescription4: "",
      lgDescription5: "",
      lgDescription6: "",
      dropzoneOptions: {
        url: process.env.VUE_APP_ROOT_API + "/api/elg/attachFile/",
        thumbnailWidth: 100,
        maxFilesize: 10, //10MB
        maxFiles: 10, //10 Files
        addRemoveLinks: true,
        headers: {
          Authorization: "Bearer " + this.$store.state.auth.token,
        },
        dictDefaultMessage: "<i class='fa fa-cloud-upload'></i> อัพโหลดไฟล์",
        acceptedFiles: "image/*,application/pdf",
        init: function() {
          this.on("addedfile", function(file) {
            var _this = this;
            this.on("success", function(file, data) {
              var ext = file.name.split(".").pop();

              file.requestId = data.requestId;
              file.seq = data.seq;
            });
            this.on("error", function (file, message) {
              this.removeFile(file);
            }); 
          });
        },
      },
    };
  },
  watch: {
    lgFormNoExtendTop() {
      this.lgFormNo = this.lgFormNoExtendTop;
      this.dynamicBene();
    },
    contingent(newVal, oldVal) {
      this.appVo = null;
    },
  },
  computed: {
    ...mapGetters(["isAuthenticated", "authStatus"]),
    loading: function() {
      return this.authStatus === "loading" && !this.isAuthenticated;
    },

    dynamicType() {
      const beneCode = localStorage.getItem("beneGroup");
      const lgType = localStorage.getItem("lgType");

      return () => import(`@/components/request/new`);
    },

    dynamicBene() {
      let lgGroup = this.lgGroup;
      let lgType = this.lgType;
      let lgFormNoExtendTop = this.lgFormNoExtendTop;
      if ((lgGroup === "PEA" && lgType === "5")) {
        return () => import(`@/components/request/new/${lgGroup}_${lgType}`);
      } else if (lgGroup === "PTTGC") {
        if (lgType === "1" || lgType === "7") {
            return () => import(`@/components/request/new/PTTGC_1`);
          } else {
            return () => import(`@/components/request/new/PTTGC_2`);
          }
      } else if (lgGroup === "SCG") {
          if (lgType !== "7") {
            return () =>
              import(`@/components/request/new/${lgGroup}_${lgType}`);
          } else {
            return () => import(`@/components/request/new/DEFAULT`);
          }
      } else if (lgGroup === "") {
        return () => import(`@/components/request/new/DEFAULT_2`);
      } else {
        return () => import(`@/components/request/new/DYNAMIC_SPECIFIC_FIELD`);
      }
    },

    dynamicIncType() {
      if (this.$parent.reqType == 3 || this.$parent.reqType == 4) {
        return () => import(`@/components/request/extend/increase`);
      }
    },

    dynamicExtType() {
      if (this.$parent.reqType == 2 || this.$parent.reqType == 4) {
        return () => import(`@/components/request/extend/extend`);
      }
    },

    dynamicBC() {
      if (this.appVo.bcFlag !== "1" && this.appVo.lgProduct != "ELG") {
        //if (this.appVo.bcFlag !== "1") {
        return () => import(`@/components/request/extend/noneBC`);
      }
    },
  },

  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    getFeeAmount() {
      return new Promise((resolve, reject) => {
        if (
          this.commNo !== undefined &&
          this.commNo != "" &&
          this.commNo !== null &&
          this.lgType !== undefined &&
          this.lgType != "" &&
          this.lgType !== null
        ) {
          let vperiodStartDate = "-";
          let vperiodEndDate = "-";

          if (this.extperiodType == 2) {
            if (
              this.extperiodStartDate1 !== null &&
              this.extperiodStartDate1 !== undefined &&
              this.extperiodStartDate1 !== "" &&
              this.extperiodEndDate !== null &&
              this.extperiodEndDate !== undefined &&
              this.extperiodEndDate !== ""
            ) {
              vperiodStartDate = moment(this.extperiodStartDate1).format(
                "YYYYMMDD"
              );
              vperiodEndDate = moment(this.extperiodEndDate).format("YYYYMMDD");
            }
          } else if (this.extperiodType == 1) {
            if (
              this.extperiodStartDate2 !== null &&
              this.extperiodStartDate2 !== undefined &&
              this.extperiodStartDate2 !== ""
            ) {
              vperiodStartDate = moment(this.extperiodStartDate2).format(
                "YYYYMMDD"
              );
            }
          }

          let calAmount = 0;
          if (this.reqType == 2) {
            calAmount = this.appVo.lgAmt;
          } else if (this.reqType == 3) {
            calAmount = this.addLgAmt;

            if (
              this.extperiodStartDate1 !== null &&
              this.extperiodStartDate1 !== undefined &&
              this.extperiodStartDate1 !== ""
            ) {
              vperiodStartDate = moment(this.extperiodStartDate1).format(
                "YYYYMMDD"
              );
            }

            if (
              this.extperiodEndDate !== null &&
              this.extperiodEndDate !== undefined &&
              this.extperiodEndDate !== ""
            ) {
              vperiodEndDate = moment(this.extperiodEndDate).format("YYYYMMDD");
            }
          } else if (this.reqType == 4) {
            calAmount = this.sumLgAmt;
          }

          if (vperiodStartDate === "Invalid date") {
            vperiodStartDate = "-";
          }
          if (vperiodEndDate === "Invalid date") {
            vperiodEndDate = "-";
          }

          if (
            vperiodStartDate !== null &&
            vperiodStartDate !== undefined &&
            vperiodStartDate !== "-" &&
            calAmount !== null &&
            calAmount !== undefined &&
            calAmount !== "" &&
            calAmount > 0
          ) {
            apiClient
              .get(
                "/api/elg/getFeeAmount/" +
                  this.commNo +
                  "/" +
                  this.lgType +
                  "/" +
                  calAmount +
                  "/" +
                  vperiodStartDate +
                  "/" +
                  vperiodEndDate +
                  "/" +
                  this.appVo.lgAmt +
                  "/" +
                  this.$parent.reqType +
                  "/" +
                  this.appVo.beneTaxId
              )
              .then((resp) => {
                if (resp.data.feeAmount !== null) {
                  this.feeAmt = resp.data.feeAmount;
                }

                resolve();
              })
              .catch((err) => {
                if(err.response.status===401){
                  this.loader.hide();
                }
                //this.$swal("Error!", "ไม่สามารถคำนวณค่าธรรมเนียมได้ ", "error");
              });
          }
        }
      });
    },

    onChildExtIncChange(value) {
      this.extperiodType = value.extperiodType;
      this.extperiodStartDate = value.extperiodStartDate;
      this.extperiodStartDate1 = value.extperiodStartDate1;
      this.extperiodStartDate2 = value.extperiodStartDate2;
      this.extperiodEndDate = value.extperiodEndDate;
      this.periodAmt = value.periodAmt;
      this.periodUnit = value.periodUnit;
      if (
        Object.prototype.toString.call(this.extperiodStartDate1) ===
        "[object Date]"
      ) {
        this.extperiodStartDate1Text =
          moment(this.extperiodStartDate1).format("DD/MM/") +
          (moment(this.extperiodStartDate1).format("YYYY") * 1 + 543);
      }

      if (
        Object.prototype.toString.call(this.extperiodStartDate2) ===
        "[object Date]"
      ) {
        this.extperiodStartDate2Text =
          moment(this.extperiodStartDate2).format("DD/MM/") +
          (moment(this.extperiodStartDate2).format("YYYY") * 1 + 543);
      }

      if (
        Object.prototype.toString.call(this.extperiodEndDate) ===
          "[object Date]" ||
        Object.prototype.toString.call(this.extperiodEndDate) ===
          "[object Object]"
      ) {
        this.extperiodEndDateText =
          moment(this.extperiodEndDate).format("DD/MM/") +
          (moment(this.extperiodEndDate).format("YYYY") * 1 + 543);
      }

      this.getFeeAmount();
    },

    onChildIncChange(value) {
      //this.extperiodType = value.extperiodType;// hard code เพื่อให้เข้า logic เดิมในการ set ค่า start date,end date
      this.addLgAmt = value.addLgAmt;
      this.sumLgAmt = value.sumLgAmt;

      if (
        value.addPeriodStartDate !== null &&
        value.addPeriodStartDate !== ""
      ) {
        this.extperiodStartDate1 = value.addPeriodStartDate;
        this.extperiodStartDate1Text =
          moment(this.extperiodStartDate1).format("DD/MM/") +
          (moment(this.extperiodStartDate1).format("YYYY") * 1 + 543);
      }
      if (value.addPeriodEndDate !== null && value.addPeriodEndDate !== "") {
        this.extperiodEndDate = value.addPeriodEndDate;
        this.extperiodEndDateText =
          moment(this.extperiodEndDate).format("DD/MM/") +
          (moment(this.extperiodEndDate).format("YYYY") * 1 + 543);
      }

      //calculate fee amount
      this.getFeeAmount();
    },
    onChildChange(value) {
      this.ctrNo = value.ctrNo;
      this.ctrDate = value.ctrDate;
      this.securityNo = value.securityNo;
      this.caNo = value.caNo;
      this.meterNo = value.meterNo;
      this.bpNo = value.bpNo;
      this.jobPrice = value.jobPrice;
      this.middlePrice = value.middlePrice;
      this.ctrDatePEA = value.ctrDatePEA;
      this.projectName = value.projectName;
      this.percentage = value.percentage;
      this.ctrName = value.ctrName;
      this.beneficiaryRemark = value.beneficiaryRemark;
      this.manyCtrNo = value.manyCtrNo;
      this.manyCtrDate = value.manyCtrDate;
      this.guaranteePriceAmt = value.guaranteePriceAmt;
      this.hospitalCode = value.hospitalCode;
      this.hospitalName = value.hospitalName;
      this.contractTypeId = value.contractTypeId;
      this.contractTypeDesc = value.contractTypeDesc;
      this.contractPeriod = value.contractPeriod;
      this.projectId = value.projectId;
      this.seqNo = value.seqNo;
      this.projectBudgetAmt = value.projectBudgetAmt;
      this.bidExpireDate = value.bidExpireDate;
      this.projectOwner = value.projectOwner;
      this.advancePaymentAmt = value.advancePaymentAmt;
      this.collectionPhase = value.collectionPhase;
      this.productType = value.productType;
      this.dealerCode = value.dealerCode;
      this.manyCtrName = value.manyCtrName;
      this.lgDescription3 = value.lgDescription3;
      this.lgDescription2 = value.lgDescription2;
      this.lgDescription4 = value.lgDescription4;
      this.lgDescription5 = value.lgDescription5;
      this.lgDescription6 = value.lgDescription6;
    },

    onChildExtChange(value) {
      this.ctrNo = value.ctrNo;
      this.ctrDate = value.ctrDate;
      this.securityNo = value.securityNo;
      this.caNo = value.caNo;
      this.meterNo = value.meterNo;
      this.bpNo = value.bpNo;
      this.jobPrice = value.jobPrice;
      this.middlePrice = value.middlePrice;
      this.bcFlagByComNo = value.bcFlagByComNo;
      this.commNo = value.commNo;
      this.requesterList = value.requesterList;
      this.beneficiary = value.beneficiary;
      this.accNoFee = value.accNoFee;
      this.accBalFee = value.accBalFee;
      this.beneficiaryRemark = value.beneficiaryRemark;
      this.contingentTypeId = value.contingentTypeId;
      this.mtContingentId = value.mtContingentId;
      this.lgFormNo = value.lgFormNo;
      this.lgTypeName = value.lgTypeName;
      this.ctrDatePEA = value.ctrDatePEA;
      this.projectName = value.projectName;
      this.percentage = value.percentage;
      this.ctrName = value.ctrName;
      this.manyCtrNo = value.manyCtrNo;
      this.manyCtrDate = value.manyCtrDate;
      this.guaranteePriceAmt = value.guaranteePriceAmt;
      this.hospitalCode = value.hospitalCode;
      this.hospitalName = value.hospitalName;
      this.contractTypeId = value.contractTypeId;
      this.contractTypeDesc = value.contractTypeDesc;
      this.contractPeriod = value.contractPeriod;
      this.projectId = value.projectId;
      this.seqNo = value.seqNo;
      this.projectBudgetAmt = value.projectBudgetAmt;
      this.bidExpireDate = value.bidExpireDate;
      this.projectOwner = value.projectOwner;
      this.advancePaymentAmt = value.advancePaymentAmt;
      this.collectionPhase = value.collectionPhase;
      this.productType = value.productType;
      this.dealerCode = value.dealerCode;
      this.manyCtrName = value.manyCtrName;
      this.lgDescription3 = value.lgDescription3;
      this.lgDescription2 = value.lgDescription2;
      this.lgDescription4 = value.lgDescription4;
      this.lgDescription5 = value.lgDescription5;
      this.lgDescription6 = value.lgDescription6;
    },

    getLgTypeList: function() {
      apiClient
        .get("/api/home/getBeneficiaryProfile/" + this.beneficiary.beneTaxId)
        .then((resp) => {
          this.custLgTypeList = resp.data;
        })
        .catch((err) => {
          if(err.response.status===401){
            this.loader.hide();
          }
        });
    },

    initUpload(refName, doctypeId) {
      this.refDropZone = refName;
      //let myUrl = process.env.VUE_APP_ROOT_API + "/api/elg/attachFile/" + localStorage.getItem("registerVerifyId") +"/" +this.reqNo + "/" + doctypeId;
      let myUrl = process.env.VUE_APP_ROOT_API + "/api/elg/attachFile/" + localStorage.getItem("registerVerifyId") + "/" + doctypeId;
      this.$refs[refName][0].setOption("url", myUrl);
      this.$refs[refName][0].options.url = myUrl;
    },
    imageRemoved(file, error, xhr) {
      let requestId = file.requestId;
      let seq = file.seq;
      if (requestId !== undefined && seq !== undefined) {
        this.loader = this.$loading.show();
        //apiClient.get("/api/elg/removeFileUpload/" + requestId + "/" + seq);
        apiClient.get("/api/elg/removeFileUpload/" + seq);
        this.loader.hide();
      }
    },
    successUpload(file, data) {
      if (data.code === "0000") {//เก็บ docSeq ไว้เพื่อ update REQUEST_ID ตอนกด บันทึก
          console.log("data.seq = "+data.seq);
          if(this.docSeq !==""){
            this.docSeq = this.docSeq+"|"+data.seq;
          }else{
            this.docSeq = data.seq;
          }
          console.log("this.docSeq = "+this.docSeq);
      }else if (data.code === "0001") {
        this.$refs[this.refDropZone][0].removeFile(file);
        this.$swal(
          "",
          "ไม่สามารถ Upload เอกสารแนบได้ กรุณา Upload เอกสารแนบ " +
            file.name +
            " ใหม่อีกครั้ง",
          "error"
        );
      }
    },

    uploadError: function(file, error, xhr) {
      //this.$refs[this.refDropZone][0].removeFile(file);
      this.$swal(
        "",
        "รูปแบบไฟล์แนบหรือขนาดไฟล์ไม่ถูกต้อง (แนบได้ไม่เกิน 10 ไฟล์ เฉพาะ PDF และ รูป ขนาดไม่เกิน 10MB)",
        "error"
      );
    },

    updateValue(value) {
      this.$emit("input", value);
    },

    searchRequest() {
      var reqTypeTxt = "";
      if (this.$parent.reqType == "1") {
        reqTypeTxt = "NEW";
      } else if (this.$parent.reqType == "2") {
        reqTypeTxt = "EXT";
      } else if (this.$parent.reqType == "3") {
        reqTypeTxt = "INC";
      } else if (this.$parent.reqType == "4") {
        reqTypeTxt = "EXTINC";
      }
      this.loader = this.$loading.show();
      apiClient
        .post(
          "/api/elg/searchLastRequest/" +
            localStorage.getItem("registerVerifyId") +
            "/" +
            reqTypeTxt,
          {
            contingent: this.contingent,
          }
        )
        .then((resp) => {
          if (resp.data.message != "" && resp.data.message !== null) {
            this.$swal("", resp.data.message, "error");
            this.loader.hide();
          } else {
            if (
              resp.data.periodType == "1" &&
              (this.$parent.reqType == 2 || this.$parent.reqType == 4)
            ) {
              this.loader.hide();
              if (this.$parent.reqType == 2) {
                this.$swal(
                  "",
                  "หนังสือค้ำประกันแบบไม่มีกำหนดระยะเวลา ไม่สามารถทำรายการต่ออายุได้",
                  "error"
                );
              } else if (this.$parent.reqType == 4) {
                this.$swal(
                  "",
                  "หนังสือค้ำประกันแบบไม่มีกำหนดระยะเวลา ไม่สามารถทำรายการต่ออายุ+เพิ่มวงเงินได้",
                  "error"
                );
              }
            } else if (
              resp.data.beneGroup == "PEA" &&
              (this.$parent.reqType == 3 || this.$parent.reqType == 4) &&
              resp.data.contingentTypeId === "5"
            ) {
              this.loader.hide();
              if (this.$parent.reqType == 3) {
                this.$swal(
                  "",
                  "เลขที่หนังสือค้ำประกัน " +
                    this.contingent +
                    " ผู้รับผลประโยชน์ การไฟฟ้าส่วนภูมิภาค ไม่สามารถทำรายการเพิ่มวงเงินได้ <br>โปรดดำเนินการออกหนังสือค้ำประกันฉบับใหม่ (เฉพาะวงเงินค้ำประกันที่ขอเพิ่ม)",
                  "error"
                );
              } else if (this.$parent.reqType == 4) {
                this.$swal(
                  "",
                  "เลขที่หนังสือค้ำประกัน " +
                    this.contingent +
                    " ผู้รับผลประโยชน์ การไฟฟ้าส่วนภูมิภาค ไม่สามารถทำรายการต่ออายุ+เพิ่มวงเงินได้<br>โปรดดำเนินการ สร้างใบคำขอ 2 รายการ ดังนี้<br>1.ต่ออายุหนังสือค้ำประกัน (เดิม)<br>2.ออกหนังสือค้ำประกันฉบับใหม่  <br>(เฉพาะวงเงินค้ำประกันที่ขอเพิ่ม)",
                  "error"
                );
              }
            } else if (resp.data.status == "304") {
              this.loader.hide();
              this.$swal
                .fire({
                  title: "",
                  html:
                    "เลขที่หนังสือค้ำประกัน " +
                    this.contingent +
                    " </br>ผู้รับผลประโยชน์ " +
                    resp.data.beneNameTh +
                    " ไม่สามารถทำรายการเพิ่มวงเงิน ได้",
                  type: "error",
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "ตกลง",
                })
                .then((result) => {
                  if (result.value) {
                  }
                });
            } else if (
              this.$parent.reqType == 3 &&
              moment(resp.data.periodEndDate, "DD/MM/YYYY") <
                moment(new Date(), "DD/MM/YYYY")
            ) {
              this.loader.hide();
              this.$swal(
                "",
                "หนังสือค้ำประกันฉบับนี้หมดอายุแล้ว ไม่สามารถเพิ่มวงเงินได้",
                "error"
              );
            } else {
              if (resp.data && resp.data.beneGroup === "NHSO")
                this.isHideForm = true;
              else this.isHideForm = false;

              this.loader.hide();
              this.appVo = resp.data;
              this.feeAmt = resp.data.feeAmt;
              this.feeRate = resp.data.feeRate;
              this.accNoFee = resp.data.accNo;
              this.accBalFee = resp.data.accBal;
              this.commNo = resp.data.commNo;
              this.lgGroup = resp.data.beneGroup;
              this.lgType = resp.data.contingentTypeId;
              this.extPeriodType = resp.data.periodType;
              this.periodType = resp.data.periodType;
              this.oldperiodStartDate = moment(
                resp.data.periodStartDate,
                "DD/MM/YYYY"
              );
              this.oldperiodEndDate = moment(
                resp.data.periodEndDate,
                "DD/MM/YYYY"
              );
              this.bcFlagByComNo = resp.data.bcFlagByComNo;
              this.contingentTypeId = resp.data.contingentTypeId;
              this.mtContingentId = resp.data.mtContingentId;
              this.lgFormNo = resp.data.lgFormNo;
              this.lgFormNoExtendTop = resp.data.lgFormNo;
              this.beneficiaryRemark = resp.data.beneficiaryRemark;
              this.docTypeList = resp.data.docTypeList;
              if (resp.data.modifyFlag === "Y") {
                this.getFormNoList();
              }
            }
          }
        })
        .catch((err) => {
          this.loader.hide();

          //this.$swal("", "ไม่พบข้อมูล "+err, "error");
        });
    },

    getFormNoList: function() {
      console.log("this.mtContingentId :"+this.mtContingentId);
      console.log("this.appVo.mtContingentId :"+this.appVo.mtContingentId);
      return new Promise((resolve, reject) => {
        this.loader = this.$loading.show();
        apiClient
          .get(
            "/api/home/getFormNo/" +
              this.appVo.beneTaxId +
              "/" +
              this.mtContingentId
          )
          .then((resp) => {
            this.loader.hide();
            this.lgFormList = resp.data;
            if (resp.data.length === 1) {
              this.lgFormNoExtendTop = resp.data[0].lgFormNo;
            } else if (resp.data.length > 0) {
              var isMatch = "N";
              for (var i = 0; i < this.lgFormList.length; i++) {
                if (this.lgFormList[i].lgFormNo === this.lgFormNo) {
                  isMatch = "Y";
                }
              }
              if (isMatch === "N") {
                this.lgFormNoExtendTop = "";
              }
            } else {
              this.lgFormNoExtendTop = "";
              this.$swal("", "ไม่พบแบบฟอร์มสำหรับประเภทการค้ำประกันนี้", "error");
            }
            resolve();
          })
          .catch((err) => {
            if(err.response.status===401){
              this.loader.hide();
            }
          });
      });
    },

    saveRequest: function() {
      const { reqNo, reqType } = this;

      /*****************2019.09.13 Wave3 ให้ยกเลิกตรวจสอบ สามารถทำรายการก่อนหมดอายุได้**************/
      /*if(reqType==4){
        let currDate = new Date();
        let tmpStartDate = new Date();

        if (this.extperiodType == 2){
          tmpStartDate = this.extperiodStartDate1;
        }else{
          tmpStartDate = this.extperiodStartDate2;
        }

        console.log("currDate:"+currDate);
        console.log("tmpStartDate:"+tmpStartDate);
        if(currDate<tmpStartDate){
          this.$swal.fire({
            title: '',
            width: 700,
            type: 'error',            html: "กรณีต่ออายุ+เพิ่มวงเงิน ต้องทำหลังหนังสือค้ำประกันหมดอายุเท่านั้น",

            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ตกลง'
          }).then((result) => {
            if (result.value) {
            }
          });

          return;
        }
      }*/
      console.log("beneficiaryRemark:" + this.appVo.beneficiaryRemark);
      console.log("ctrNo:" + this.appVo.ctrNo);
      console.log("ctrDate:" + this.appVo.ctrDate);
      console.log("ctrName:" + this.appVo.ctrName);
      // console.log("caNo:" + this.caNo);
      if (this.reqType == 3 && this.beneficiary.beneTaxId === "0105533121519") {
        this.$swal(
          "",
          "ไม่สามารถ เพิ่มวงเงิน หนังสือค้ำประกันจาก LG ทั่วไป(กระดาษ) มาเป็น LG Blockchain ได้",
          "error"
        );
        return;
      }
      if (this.reqType == 4 && this.beneficiary.beneTaxId === "0105533121519") {
        this.$swal(
          "",
          "ไม่สามารถ ต่ออายุ+เพิ่มวงเงิน หนังสือค้ำประกันจาก LG ทั่วไป(กระดาษ) มาเป็น LG Blockchain ได้",
          "error"
        );
        return;
      }
      if (this.appVo.bcFlag !== "1" && this.appVo.lgProduct != "ELG") {
        //if (this.appVo.bcFlag !== "1") {
        if (
          this.beneficiary.beneTaxId === "" ||
          this.beneficiary.beneTaxId === null ||
          this.beneficiary.beneTaxId === undefined
        ) {
          this.$swal(
            "",
            "กรุณาระบุ ผู้รับผลประโยชน์(ผู้รับหนังสือค้ำประกัน)",
            "error"
          );
          return;
        }
        if (
          this.contingentTypeId === "" ||
          this.contingentTypeId === null ||
          this.contingentTypeId === undefined
        ) {
          this.$swal("", "กรุณาระบุ ประเภทการค้ำประกันนี้", "error");
          return;
        }
        if (
          this.commNo === "" ||
          this.commNo === null ||
          this.commNo == undefined
        ) {
          this.$swal("", "กรุณาระบุ หมายเลขบัญชีวงเงิน", "error");
          return;
        }
        if (this.requesterList === null || this.requesterList.length < 1) {
          this.$swal("", "กรุณาระบุ เพื่อค้ำประกันในนาม", "error");
          return;
        }
      }

      if (
        this.accNoFee === "" ||
        this.accNoFee === null ||
        this.accNoFee === undefined
      ) {
        this.$swal(
          "",
          "ยังไม่บันทึกข้อมูลบัญชีค่าธรรมเนียม กรุณาติดต่อธนาคาร",
          "error"
        );
        return;
      }

      var countAllFile = 0;
      for (var i = 0; i < this.docTypeList.length; i++) {
        let required_file = this.docTypeList[i].mandatFlag;
        if (
          required_file === "Y" &&
          this.$refs["myVueDropzone" + i][0].dropzone.files.length < 1
        ) {
          this.$swal("Error", "กรุณาแนบเอกสารประกอบเพิ่มเติม ", "error");
          return;
        }
        countAllFile =
          countAllFile +
          this.$refs["myVueDropzone" + i][0].dropzone.files.length;
      }

      const bcFlagByComNo = this.appVo.bcFlagByComNo;
      const beneCode = this.appVo.beneGroup;
      const contingentTypeId = this.appVo.contingentTypeId;

      //ถ้าเป็นวงเงินกระดาษต้องมีไฟล์แนบ หรือ ถ้าเป็น SCG ประเภท ปฏิบัติตามสัญญา performance bond และวงเงินที่เป็น eLG
      if (
        (((this.appVo.bcFlag === "1" && this.appVo.bcFlagByComNo !== "1") ||
          (this.appVo.bcFlag !== "1" && this.bcFlagByComNo !== "1")) &&
          countAllFile <= 0) ||
        (beneCode === "SCG" && contingentTypeId === "3" && countAllFile <= 0)
      ) {
        this.$swal("", "กรุณาแนบเอกสารประกอบเพิ่มเติม ", "error");
        return;
      }

      //check file size max 10 files.
      if (countAllFile > 10) {
        this.$swal(
          "Error",
          "ขนาดไฟล์ไม่ถูกต้อง (แนบได้ทั้งหมดไม่เกิน 10 ไฟล์)",
          "error"
        );
        return;
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          var periodDateStr = "";
          if (this.reqType == 2 || this.reqType == 4) {
            //ต่ออายุ
            if (this.extperiodType == 2) {
              //มีกำหนด, เงื่อนไข undefined จะใช้กรณีที่ค้นหาครั้งแรก ไม่รู้ทำไม set extperiodType = periodType ไม่ได้ในครั้งแรก
              let periodStartDate = this.extperiodStartDate1Text;
              let periodEndDate = this.extperiodEndDateText;
              periodDateStr = periodStartDate + " ถึง " + periodEndDate;
            } else {
              //ไม่มีกำหนด
              let periodStartDate = this.extperiodStartDate2Text;
              periodDateStr = periodStartDate;
            }
          } else {
            //เพิ่มวงเงิน
            let periodStartDate = this.extperiodStartDate1Text;

            if (this.periodType == "2") {
              let periodEndDate = this.extperiodEndDateText;
              periodDateStr = periodStartDate + " ถึง " + periodEndDate;
            } else {
              periodDateStr = periodStartDate;
            }
          }

          var tmpLGAmt = this.appVo.lgAmt;
          if (this.sumLgAmt !== null && this.sumLgAmt > 0) {
            tmpLGAmt = this.sumLgAmt;
          }

          var strRequest = "";

          if (
            this.appVo != null &&
            this.appVo.requesterList != null &&
            this.appVo.requesterList.length
          ) {
            const requesterList = this.appVo.requesterList;

            if (requesterList != null && requesterList.length > 0) {
              for (var i = 0; i < requesterList.length; i++) {
                strRequest =
                  strRequest +
                  "<li>" +
                  requesterList[i].guaranteeTaxId +
                  " : " +
                  requesterList[i].guaranteeName +
                  "</li>";
              }
            }
          }

          var strBeneName = this.appVo.beneNameTh;
          var strLgTypeName = this.appVo.contingentTypeName;

          if (
            this.appVo.bcFlag !== "1" &&
            !(this.appVo.bcFlag === "0" && this.appVo.lgProduct === "ELG")
          ) {
            //lg กระดาษ

            strBeneName = this.beneficiary.beneName;
            strRequest = "";

            if (this.requesterList != null && this.requesterList.length > 0) {
              for (let i = 0; i < this.requesterList.length; i++) {
                strRequest =
                  strRequest +
                  "<li>" +
                  this.requesterList[i].guaranteeTaxId +
                  " : " +
                  this.requesterList[i].guaranteeName +
                  "</li>";
              }
            }
            strLgTypeName = this.lgTypeName;
          } else {
            //กรณีต่ออายุ blockchain ปกติให้ set เป็นค่าจาก appVo
            this.requesterList = this.appVo.requesterList;
          }
          if (this.requesterList != null && this.requesterList.length > 0) {
            for (let i = 0; i < this.requesterList.length; i++) {
              if (this.requesterList[i].guaranteeName.trim() === "") {
                this.$swal(
                  "",
                  "กรุณาระบุ เพื่อค้ำประกันในนาม ชื่อภาษาไทย",
                  "error"
                );
                return;
              }
            }
          }
          var strFee = "";
          if (
            (this.appVo.bcFlag === "1" && this.appVo.bcFlagByComNo !== "1") ||
            (this.appVo.bcFlag !== "1" && this.bcFlagByComNo !== "1")
          ) {
            strFee = "ค่าธรรมเนียมขั้นต่ำ 500 บาท หรือเป็นไปตามระเบียบธนาคาร";
            this.feeAmt = null;
            this.bcFlag = "0";
          } else {
            strFee = this.formatPrice(this.feeAmt);
            this.bcFlag = "1";
          }

          this.$swal
            .fire({
              title: "กรุณาตรวจสอบรายละเอียดก่อนดำเนินการ?",
              width: 600,
              html:
                "<div class='card-body compact-padding'>" +
                "  <div class='default-padding'>" +
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>หมายเลขอ้างอิงรายการ</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                reqNo +
                " " +
                "      </div>" +
                "    </div>" +
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>ผู้ขอออกหนังสือค้ำประกัน</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                this.appVo.requesterTaxId +
                " " +
                this.appVo.requesterNameTh +
                " " +
                "      </div>" +
                "    </div>" +
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>ผู้รับผลประโยชน์</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                strBeneName +
                " " +
                "      </div>" +
                "    </div>" +
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>ประเภทการค้ำประกัน</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                strLgTypeName +
                " " +
                "      </div>" +
                "    </div>" +
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>เพื่อค้ำประกันในนาม</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                strRequest +
                "      </div>" +
                "    </div>" +
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>จำนวนเงินค้ำประกัน (บาท)</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                this.formatPrice(tmpLGAmt) +
                " " +
                "      </div>" +
                "    </div>" +
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>มีผลบังคับใช้ตั้งแต่วันที่</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                periodDateStr +
                " " +
                "      </div>" +
                "    </div>" +
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>ค่าธรรมเนียม (บาท)</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                strFee +
                " " +
                "      </div>" +
                "    </div>" +
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>ค่าอากรแสตมป์ (บาท)</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                this.formatPrice(this.dutyStampAmt) +
                " " +
                "      </div>" +
                "    </div>" +
                "  </div>" +
                "</div>",

              //type: 'warning',
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              cancelButtonText: "ยกเลิก",
              confirmButtonText: "ยืนยันการทำรายการ",
            })
            .then((result) => {
              if (result.value) {
                var reqTypeTxt = "";

                if (this.reqType == "1") {
                  reqTypeTxt = "NEW";
                } else if (this.reqType == "2") {
                  reqTypeTxt = "EXT";
                } else if (this.reqType == "3") {
                  reqTypeTxt = "INC";
                } else if (this.reqType == "4") {
                  reqTypeTxt = "EXTINC";
                }

                //set periodStartDate

                let vperiodStartDate = "";
                let vperiodEndDate = "";

                if (this.extperiodType == 2) {
                  vperiodStartDate = moment(this.extperiodStartDate1).format(
                    "YYYYMMDD"
                  );
                  vperiodEndDate = moment(this.extperiodEndDate).format(
                    "YYYYMMDD"
                  );
                } else {
                  vperiodStartDate = moment(this.extperiodStartDate2).format(
                    "YYYYMMDD"
                  );
                }

                var date1 = "";
                if (this.reqType == 2 || this.reqType == 4) {
                } else {
                  //เพิ่มวงเงิน
                  this.extperiodType = this.periodType;
                  vperiodStartDate = moment(this.extperiodStartDate1).format(
                    "YYYYMMDD"
                  );
                  if (this.periodType == "2") {
                    //มีกำหนด
                    vperiodEndDate = moment(this.extperiodEndDate).format(
                      "YYYYMMDD"
                    );
                  } else {
                    vperiodEndDate = "";
                  }
                }

                this.sumLgAmt = this.appVo.lgAmt;

                let vctrDate = "";
                if (
                  typeof this.ctrDate !== undefined &&
                  this.ctrDate !== ""
                ) {
                  vctrDate = moment(this.ctrDate).format("YYYYMMDD");
                }
                if (vctrDate === "Invalid date") {
                  vctrDate = "";
                }


                let vctrDatePEA = "";
                if (this.ctrDatePEA !== undefined && this.ctrDatePEA !== "") {
                  vctrDatePEA = moment(this.ctrDatePEA).format("YYYYMMDD");
                }
                if (vctrDatePEA === "Invalid date") {
                  vctrDatePEA = "";
                }

                let vBidExpireDate = "";
                if (this.bidExpireDate !== undefined && this.bidExpireDate !== "") {
                  vBidExpireDate = moment(this.bidExpireDate).format("YYYYMMDD");
                }
                if (vBidExpireDate === "Invalid date") {
                  vBidExpireDate = "";
                }

                let vLgDescription4 = "";
                if (this.lgDescription4 !== "undefined" && this.lgDescription4 !== "") {
                  vLgDescription4 = moment(this.lgDescription4).format("YYYYMMDD");
                }
                if (vLgDescription4 === "Invalid date") {
                  vLgDescription4 = "";
                }

                if(this.lgGroup ==="NHSO"){
                  this.beneficiary.beneTaxId = this.appVo.beneTaxId;
                }
                this.loader = this.$loading.show();
                apiClient
                  .post(
                    "/api/elg/extend/" +
                      localStorage.getItem("registerVerifyId"),
                    {
                      reqNo: reqNo,
                      status: "PS",
                      reqType: reqTypeTxt,
                      cifNo: localStorage.getItem("cifNo"),
                      requesterTaxId: this.appVo.requesterTaxId,
                      requesterNameTh: this.appVo.requesterNameTh,
                      requesterNameEn: this.appVo.requesterNameEn,
                      beneTaxId: this.beneficiary.beneTaxId,
                      beneGroup: this.beneficiary.beneGroup,
                      beneNameTh: this.beneficiary.beneName,
                      //contingentTypeId: this.appVo.contingentTypeId,
                      lgAmt: tmpLGAmt,
                      lgAmtInc: this.addLgAmt,
                      periodType: this.extperiodType,
                      periodStartDate: vperiodStartDate,
                      periodEndDate: vperiodEndDate,
                      periodAmt: this.periodAmt,
                      periodUnitId: this.periodUnit,
                      commNo: this.commNo,
                      feeCcy: "THB",
                      lgCcy: "THB",
                      contingentNo: this.contingent,
                      feeAmt: this.feeAmt,
                      accNo: this.accNoFee,
                      caNo: this.caNo,
                      securityNo: this.securityNo,
                      bpNo: this.bpNo,
                      meterNo: this.meterNo,
                      jobPrice: this.jobPrice,
                      middlePrice: this.middlePrice,
                      ctrNo: this.ctrNo,
                      ctrDate: vctrDate,
                      beneficiaryRemark: this.beneficiaryRemark,
                      contingentTypeId: this.contingentTypeId,
                      mtContingentId: this.mtContingentId,
                      lgFormNo: this.lgFormNo,
                      bcFlag: this.bcFlag,
                      requesterList: this.requesterList,
                      ctrDatePEA: vctrDatePEA,
                      projectName: this.projectName,
                      percentage: this.percentage,
                      ctrName: this.ctrName,
                      lgFormNoExtendTop: this.lgFormNoExtendTop,
                      manyCtrNo: this.manyCtrNo,
                      manyCtrDate: this.manyCtrDate,
                      guaranteePriceAmt: this.guaranteePriceAmt,
                      hospitalCode: this.hospitalCode,
                      hospitalName: this.hospitalName,
                      contractTypeId: this.contractTypeId,
                      contractTypeDesc: this.contractTypeDesc,
                      contractPeriod: this.contractPeriod,
                      projectId: this.projectId,
                      seqNo: this.seqNo,
                      projectBudgetAmt: this.projectBudgetAmt,
                      bidExpireDate: vBidExpireDate,
                      projectOwner: this.projectOwner,
                      advancePaymentAmt: this.advancePaymentAmt,
                      collectionPhase: this.collectionPhase,
                      productType: this.productType,
                      dealerCode: this.dealerCode,
                      docSeq: this.docSeq,
                      manyCtrName: this.manyCtrName,
                      lgDescription3: this.lgDescription3,
                      lgDescription2: this.lgDescription2,
                      lgDescription4: vLgDescription4,
                      lgDescription5: this.lgDescription5,
                      lgDescription6: this.lgDescription6
                    }
                  )
                  .then((resp) => {
                    this.loader.hide();
                    if (resp.data.code == "0000") {
                      //success
                      this.$swal("", "บันทึกส่งข้อมูลเรียบร้อย\n หมายเลขอ้างอิงรายการ : "+resp.data.requestId, "success");
                      this.$router.push("/apphistory");
                    } else {
                      this.$swal(
                        "",
                        "ดำเนินการไม่สำเร็จ " + resp.data.message,
                        "error"
                      );
                    }
                  })
                  .catch((err) => {
                    if(err.response.status===401){
                      this.loader.hide();
                    }
                  });
              } else {
                //ถ้ากดยกเลิก
              }
            });
        } else {
          this.$swal("", "กรุณากรอกข้อมูลให้ครบถ้วน ", "error");
        }
      });
    },
  },

  mounted() {
    apiClient
      .get(
        "/api/elg/defaultRequest/" + localStorage.getItem("registerVerifyId")
      )
      .then((resp) => {
        this.reqNo = resp.data.reqNo;
      });
  },
};
</script>
<style>
.hideForm {
  display: none;
}
</style>
